export default __webpack_public_path__ + "static/media/flag-el-salvador.e1539bb0.svg";